<template>
    <div class="padding-left-right padding-top-bottom-20 bg-light margin-bottom" v-if="info">
        <a :href="'/bids/detail/'+info.id+($utils.querystring($route.query) ? '?'+$utils.querystring($route.query) : '')" class="dark-1">
            <div class="f-b">{{info.title}}</div>
            <van-row class="margin-top flex flex-row flex-ai">
                <van-col span="8" class="dark-2 f12 flex flex-ai" v-if="info.industry">
                    <van-icon name="apps-o" size="14" class="margin-right-5"/>{{info.industry.name}}
                </van-col>
                <van-col span="8" class="dark-2 f12 flex flex-ai">
                    <van-icon name="location-o" size="14" class="margin-right-5"/>{{info.province_name}}
                </van-col>
                <van-col span="8" class="dark-2 f12 flex flex-ai">
                    <van-icon name="clock-o" size="14" class="margin-right-5"/>{{info.create_time ? $moment(info.create_time).format('YYYY-MM-DD') : '-'}}
                </van-col>
            </van-row>
        </a>
    </div>
</template>

<script>
export default {
    name: "BidsItem",
    props:{
        info:{
            type:[Array,Object],
            default(){
                return null
            }
        },
    }
}
</script>
